/** Invitation à la première connexion (spec § 4.3). Sous le verrou de saisie et sous la visite (z-index). */
import React from 'react';
import { createPortal } from 'react-dom';

const BTN = {
  padding: '8px 16px', fontSize: 13, fontWeight: 600, borderRadius: 6, cursor: 'pointer',
  fontFamily: "'IBM Plex Sans', sans-serif", border: '1px solid #d1d5db', background: '#fff', color: '#374151',
};

export default function PremiersPasInvite({ prenom, onCommencer, onPlusTard, onJamais }) {
  return createPortal(
    <div role="dialog" aria-modal="true" aria-labelledby="premiers-pas-titre"
      style={{ position: 'fixed', inset: 0, zIndex: 99990, background: 'rgba(15,23,42,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: 440, maxWidth: '100%', background: '#fff', borderRadius: 12, padding: 24,
        boxShadow: '0 8px 32px rgba(0,0,0,0.18)', fontFamily: "'IBM Plex Sans', sans-serif" }}>
        <h2 id="premiers-pas-titre" style={{ margin: '0 0 10px', fontSize: 18, color: '#111827' }}>
          Bienvenue{prenom ? ` ${prenom}` : ''} sur le portail METERIS
        </h2>
        <p style={{ margin: '0 0 18px', fontSize: 14, color: '#374151', lineHeight: 1.6 }}>
          Une visite guidée d'une dizaine de minutes : ta journée, les tickets, les appels, les ordinateurs,
          le coffre-fort et ta saisie. Tu peux l'arrêter et la reprendre quand tu veux depuis le bouton ?.
        </p>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <button type="button" onClick={onCommencer} style={{ ...BTN, background: '#0099D6', color: '#fff', border: 'none' }}>Commencer</button>
          <button type="button" onClick={onPlusTard} style={BTN}>Plus tard</button>
          <button type="button" onClick={onJamais}
            style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer', textDecoration: 'underline' }}>
            Ne plus proposer
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
